import React, { Component } from 'react';
import NProgress from 'nprogress'

import Grid from '../Grid';
import ElementShortcuts from '../ElementShortcuts';
import PlayButton from '../PlayButton';

import NumberUtils from '../../services/NumberUtils.js';
import Train from '../../services/train.js';
import Notification from '../../services/Notification.js'

import '../../../css/LastfmUser.css';
import '../../../css/elementPage.css';

class LastfmUser extends Component {

  constructor(props, context) {
    super(props, context);
    this.state = {
      user: undefined,
    }
  }

  fetchData(userName) {
    NProgress.start();

    Train.fetchLastfmUser({user: userName})
    .then((user) => {
      this.setState({user, userName});
      NProgress.done();
    }).catch((e) => {
      NProgress.done();
      Notification.show('Error loading last.fm user data', 'error');
    });

  }

  componentDidMount() {
    this.fetchData(this.props.match.params.user);
  }

  render() {

    let user = this.state.user;

    if (!user) {
      return <div className="elementPage"></div>;
    }

    let imageStyle = {
      backgroundImage: `url(${user.img})`
    };

    return (
 
      <div className="elementPage">

        <div className="header">

          <div className="profileImage" style={imageStyle}></div>
    
          <div className="content">

            <h1>{this.state.userName}</h1><PlayButton type={'lastfmUser'} element={user}/>
            
            <br/>
            
            <div className="stats">
              <span><b>Plays</b> {NumberUtils.abbreviation(user.stats.playcount)}</span>
              { user.stats.country && user.stats.country.toLowerCase() !== 'none' && <span><b>Country</b> {user.stats.country}</span> }
            </div>

            <ElementShortcuts type={'lastfmUser'} element={user}/>

          </div>

        </div>

        <Grid title="Top artists" type="artist" carousel={true} playable={true} elements={user.topArtists}/>
        <Grid title="Top albums" type="album" carousel={true} playable={true} elements={user.topAlbums}/>
        <Grid title="Top tracks" type="track" carousel={true} playable={true} elements={user.topTracks}/>
        
      </div>
              
    ); 

  }
}

export default LastfmUser;



// WEBPACK FOOTER //
// ./src/js/components/lastfm_user/LastfmUser.jsx